export default __webpack_public_path__ + "static/publisher_app@2x-9995b0b5b372f06e321f0ae41f265b4c.png";